var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMhub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    viewBox: "0 0 27 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41129 7.15332L0 13.8287V7.15332H6.41129Z",
    fill: "#596975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87085 7.15332L13.2821 13.8287V7.15332H6.87085Z",
    fill: "#596975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1288 7.15332L13.7175 13.8287V7.15332H20.1288Z",
    fill: "#596975"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5889 7.1543L27.0002 13.8296V7.1543H20.5889Z",
    fill: "#596975"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41129 0L0 6.67533H6.41129V0Z",
    fill: "#596975"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1291 0L13.7178 6.67533H20.1291V0Z",
    fill: "#596975"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87085 0L13.2821 6.67533H6.87085V0Z",
    fill: "#596975"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5889 0L27.0002 6.67533H20.5889V0Z",
    fill: "#596975"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhub);
export default __webpack_public_path__ + "static/media/mhub.88cd4068.svg";
export { ForwardRef as ReactComponent };